import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './WizardBreadCrumbComponent.css';

class WizardBreadCrumbComponent extends Component {
  static propTypes = {
    navigationSteps: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        iconClass: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        onClick: PropTypes.func
      })
    ).isRequired,
    activeStep: PropTypes.object.isRequired
  };
  render() {
    const { navigationSteps = [] } = this.props;
    const wizardBreadCrumb = navigationSteps.map(step => this.buildWizardBreadCrumbComponent(step));
    return <div className="wizardBreadCrumb">{wizardBreadCrumb}</div>;
  }

  buildWizardBreadCrumbComponent = step => {
    const isStepActive = this.isStepActivated(step.id);
    return (
      <div className="stepWithProgressLine" key={step.id}>
        <div
          className={`step ${isStepActive ? 'clickable' : 'notClickable'}`}
          onClick={() => {
            if (isStepActive) {
              step.onClick && step.onClick();
            }
          }}>
          <div className={`stepIcon ${isStepActive ? step.iconClass : 'notNavigated'}`} />
          <div className={`stepName ${isStepActive ? 'true' : 'false'}`}>{step.title}</div>
        </div>
        {!this.isLastStep(step.id) && (
          <div className={`progressLine ${this.isNextStepActive(step.id) ? 'true' : 'false'}`}>
            <hr />
          </div>
        )}
      </div>
    );
  };

  findStepIndexById = stepId => {
    const { navigationSteps } = this.props;
    return navigationSteps.findIndex(x => x.id === stepId);
  };

  isStepActivated = stepId => {
    const { activeStep } = this.props;
    return this.findStepIndexById(stepId) <= this.findStepIndexById(activeStep.id);
  };

  isLastStep(stepId) {
    const { navigationSteps } = this.props;
    return this.findStepIndexById(stepId) + 1 === navigationSteps.length;
  }
  isNextStepActive(stepId) {
    const { activeStep } = this.props;
    return this.findStepIndexById(stepId) + 1 <= this.findStepIndexById(activeStep.id);
  }
}

export default WizardBreadCrumbComponent;



// WEBPACK FOOTER //
// ./src/Components/WizardBreadCrumb/WizardBreadCrumbComponent.js